import { getToken } from './api';
var socket;

// 本地调试
// var url = location.protocol === 'https:' ?
//     'wss://192.168.26.131/ws' :
//     'ws://192.168.26.131:9502';
// 测试、线上
var url = location.protocol === 'https:' ?
    'wss://' + window.location.hostname + '/ws' :
    'ws://' + window.location.hostname + ':9501';

if (location.hostname === 'localhost') {
    url = 'ws://test.aivideo8.com:9501';
}

/**
 * 
 * @returns {Promise<WebSocket?>}
 */
export default async function () {
    if (!socket) {
        const token = await getToken();
        socket = token ? new WebSocket(url) : null;
        if (token) {
            socket.addEventListener('open', function (event) {
                // console.log('socket opened at:', new Date());
                socket.send(JSON.stringify({ "token": token }))

                // 定时给服务端发送消息以保持socket链接不断开
                setInterval(function () {
                    console.log('向服务器发送')
                    socket.send(JSON.stringify({ "token": token }))
                }, 30000);
            });

            socket.addEventListener('close', function (event) {
                console.log('websocket 断开：' + event.code + ' ' + event.reason + ' ' + event.wasClean)
                // console.log('socket closed at:', new Date());
            });

            window.addEventListener('beforeunload', function () {
                socket.close();
            });
        }
    }
    return socket;
}